import { device } from "shared/constants/device";
import styled from "styled-components";

export const LayoutExternalContainer = styled.div`
  background-color: rgb(255, 255, 255);
  padding: 10px 0px;
`;
export const LayoutExternalContainerInner = styled.div`
  margin: 0 auto;
  flex: 1;
  width: 500px;
  padding: 30px 30px;
  border-radius: 5px;
  font-size: 14px;
  background: #fff;
  box-shadow: 0 3px 10px 0 rgb(0 0 0 / 14%);
  @media ${device.mobileL} {
    width: 100%;
    padding: 10px;
  }
`;
